// extracted by mini-css-extract-plugin
export default {"instance-roles-table__delete":"InstanceRolesTable_instance-roles-table__delete__YL2NY"};